import { Link, useNavigate } from "react-router-dom";
import {
  formatCurrency,
  getAssetCoin,
  getAssetName,
  normalizeBotName,
} from "../../utils";
import { IconBot } from "../dashboard/BotSection";
import { useBot } from "../../context/botContext";
import CoinLogo from "../commons/CoinLogo";
import BotLogo from "../commons/BotLogo";

const CardActiveBot = ({ bot, handleBotClick, selectedBot, isBotListPage }) => {
  const { setSelectedBot } = useBot();
  const navigate = useNavigate();

  const baseCurrency = bot?.coin_name?.split("/")[1] || "USDT";

  return (
    <div
      className={`p-4 cursor-pointer ${
        bot.bot_status === "active"
          ? "bg-white"
          : "bg-gray-200 border-gray-300 "
      } rounded-lg flex-1 ${
        selectedBot?.id === bot?.id && isBotListPage
          ? "border-[#007A78] border-[1.8px]"
          : isBotListPage
            ? "border-gray-200 border-[1.8px] "
            : ""
      }`}
      onClick={() => (isBotListPage ? handleBotClick(bot) : {})}
    >
      <div className="flex justify-between items-start mb-3 w-full">
        <div className="w-full">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-gray-800 text-sm md:text-xl">
              {bot.coin_name}
            </h3>
            <div className="flex items-center space-x-1">
              {/* <IconBot
                src={getAssetCoin(bot.coin_name.split("/")[0])}
                alt={bot.coin_name}
                className={"!w-[24px] !h-[24px]"}
              /> */}
              <CoinLogo
                asset={getAssetName(bot?.coin_name)}
                className={`w-full max-w-[18px] h-[18px] md:max-w-[24px] md:h-[24px] rounded-full border-2 border-white object-cover  flex-shrink-0`}
              />
              <span
                className={`bg-white border ${
                  bot.bot_status === "active"
                    ? "!border-[#1E8610] !text-[#1E8610]"
                    : "!border-gray-500 !text-gray-500"
                }  text-[10px] md:text-xs px-2 py-0.5 rounded-full flex items-center capitalize`}
              >
                <span
                  className={`w-1 h-1 md:w-2 md:h-2 ${
                    bot.bot_status === "active" ? "bg-green-500" : "bg-gray-500"
                  }  rounded-full mr-1.5`}
                ></span>
                {bot.bot_status}
              </span>
            </div>
          </div>
          <div className="flex flex-col min-[320px]:flex-row min-[320px]:items-center text-xs gap-2 min-[320px]:gap-0 text-gray-500 mt-1">
            <div className="w-full max-w-fit flex items-center">
              {/* {icons && icons.exchange ? (
                React.cloneElement(icons.exchange, {
                  className: "w-5 h-5 rounded-full",
                })
              ) : (
              )} */}
              {/* <BinanceIcon /> */}

              <IconBot
                src={`/images/icons/icon_wallet_${bot.exchange}.svg`}
                alt={bot.exchange}
                className={"relative z-[2] flex-shrink-0"}
              />
              <BotLogo
                botName={bot?.bot_strategy}
                className="relative z-[1] !ml-[-.75rem] w-[38px] h-[38px] !justify-center !flex !items-center flex-shrink-0"
                size={42}
              />
              {/* <IconBot
                src={
                  bot?.bot_strategy?.toLowerCase() === "rebalance"
                    ? "/images/icons/icon_bot_rebalance.svg"
                    : bot?.bot_strategy?.toLowerCase() === "dca"
                    ? "/images/icons/icon_bot_dca.svg"
                    : "/images/icons/icon_bot_xenoarc.svg"
                }
                alt={bot.bot_strategy}
                className={"!ml-[-.75rem] relative z-[1]"}
              /> */}
            </div>
            <span className="w-full flex whitespace-nowrap capitalize py-[2px] min-[320px]:border-l-2 min-[320px]:pl-2 min-[320px]:ml-2">
              {/* {bot.exchange} &middot; {bot.bot_strategy}{" "} */}
              {bot.exchange} &middot; {normalizeBotName(bot.bot_strategy)}{" "}
            </span>
          </div>
        </div>
      </div>

      <div>
        <p className="text-base text-black font-medium mb-0.5">Investment</p>
        <div className="flex flex-col min-[320px]:flex-row items-start  gap-2 min-[320px]:gap-0 justify-between min-[320px]:items-baseline">
          <div className=" flex flex-col items-start">
            {" "}
            <p className="text-[10px] md:text-xs text-gray-400 my-0">Starting Value</p>
            <span className="text-xs md:text-sm font-semibold text-gray-800">
              {formatCurrency(bot.starting_value || 0)} {baseCurrency}
            </span>
          </div>
          <div className="flex flex-col min-[320px]:items-end">
            {" "}
            <p className="text-[10px] md:text-xs text-gray-400 min-[320px]:text-right my-0">
              Current Value
            </p>
            <span className={`text-xs md:text-sm font-bold text-[#007A78] min-[320px]:text-right`}>
              {formatCurrency(bot.current_value || 0)} {baseCurrency}
            </span>
          </div>
        </div>
      </div>

      {!isBotListPage && (
        <div className="text-right mt-2 cursor-pointer">
          <a
            onClick={() => {
              setSelectedBot(bot);
              navigate("/bot-list");
            }}
            className="w-full text-xs text-teal-600 font-medium py-2 border !border-[#007A78] rounded-lg hover:bg-gray-50 transition-colors !bg-transparent px-3"
          >
            Detail
          </a>
        </div>
      )}
    </div>
  );
};

export default CardActiveBot;
